import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ServiceChargeStatus } from '../../../../../swagger/dto'

const mapColor = {
    [ServiceChargeStatus.ACCEPT]: '#019555',
    [ServiceChargeStatus.FREEZE]: '#ED9121',
    [ServiceChargeStatus.REFUND]: '#EF4848',
}

const getStatusLabel = (status, t) => {
    switch (status) {
        case ServiceChargeStatus.ACCEPT:
            return t('finances.statusAccept')
        case ServiceChargeStatus.FREEZE:
            return t('finances.statusFreeze')
        case ServiceChargeStatus.REFUND:
            return t('finances.statusRefund')
        default:
            return status
    }
}

export const BillingStatus = ({ status }) => {
    const { t } = useTranslation()
    
    return (
        <Typography variant="caption2" sx={{ color: mapColor[status] }}>
            {getStatusLabel(status, t)}
        </Typography>
    )
}
